/* unplugin-vue-components disabled */import script from "./FloatingAssistantFab.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingAssistantFab.vue?vue&type=script&setup=true&lang=js"

import "./FloatingAssistantFab.vue?vue&type=style&index=0&id=0f1a76ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1a76ec"]])

export default __exports__